import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const SITE_REALTIME_REPORT_ID = `site${REALTIME_CAMPAIGN_SUFFIX}`;
